import styled, { css } from 'styled-components';
import { Button } from '@perch-labs/shrike';

export const Input = styled.input`
  background: none;
  border: none;
  box-sizing: border-box;
  color: ${props => props.theme.colors.content.primary};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  font-size: ${props => props.theme.fontSizes[500]};
  height: 28px;
  line-height: ${props => props.theme.lineHeights.small};
  padding: 0;
  &:focus {
    outline: transparent solid 2px;
    border: none;
  }
  width: 100%;
`;

const inputBorderStyle = css`
  border: 1px solid ${props => props.theme.colors.background.controls};
  border-radius: ${props => props.theme.borderRadii.small};
  margin-top: 4px;
  &:focus-within {
    outline: transparent solid 2px;
    border: 1px solid ${props => props.theme.colors.background.primaryInverse};
    box-shadow: 0 0 0 1px
      ${props => props.theme.colors.background.primaryInverse};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 12px 0 16px;
  background-color: ${props => props.theme.colors.background.primary};
  ${inputBorderStyle}
`;

export const StyledButton = styled(Button).attrs({
  backgroundless: true,
})`
  background: none;
  border: none;
  color: ${props => props.theme.colors.content.primary};
  height: 24px;
  line-height: 12px;
  padding: 0;
  width: 24px;

  &:focus {
    transition: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.content.primary};
    outline: transparent solid 2px;
    border: 1px solid ${props => props.theme.colors.content.primary};
  }
`;
